/* eslint-disable react/react-in-jsx-scope */
import ReactBreadcrumb from "@/components/breadcrumb/Breadcrumb";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { listAllMonths } from "@/constants/constants";
import NewContributions from "@/contributions/NewContributions";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams, useSearchParams } from "react-router-dom";

const Contributions = ({ id = null }: { id?: number | null }) => {
  const { t } = useTranslation("dashboard", {
    keyPrefix: "financeur",
  });
  const { firstname } = useParams();
  const launchDate = 2025;
  const [searchParams, setSearchParams] = useSearchParams();
  const yearParam = searchParams.get("year");
  const [year, setYear] = useState(
    yearParam ? parseInt(yearParam) : launchDate
  );
  const [loading, setLoading] = useState(false);
  //a changer
  const expectedDurationYear = 24;
  const arrYear = Array.from(
    { length: expectedDurationYear },
    (_, index) => index + 1
  );

  const handleYearChange = (action: "prev" | "next") => {
    const currentYear = action === "prev" ? year - 1 : year + 1;
    setSearchParams({ year: currentYear.toString() });
  };

  const handleSelectYear = (value: string) => {
    const currentYear = Number(value);
    setSearchParams({ year: currentYear.toString() });
  };

  useEffect(() => {
    const yearParam = searchParams.get("year");
    if (yearParam) {
      setYear(parseInt(yearParam));
    }
  }, [searchParams]);

  return (
    <div>
      {id === null && (
        <ReactBreadcrumb
          items={[
            {
              href: `/${firstname}`,
              name: t("Tableau de bord"),
            },
            {
              href: ``,
              name: t("Suivi de contributions"),
            },
          ]}
          isTruncated={false}
        />
      )}

      <div className="flex flex-wrap gap-5 items-start justify-between mt-8 ">
        {id === null && (
          <h1
            className="mb-2 text-[24px] font-medium inline-block"
            id="program-title"
          >
            {t("Suivi de contributions")}
          </h1>
        )}
        {/* <div className="flex flex-col items-end">
          <Link
            to="/dashboard/ajout-financeur"
            className={buttonVariants({ variant: "default" })}
          >
            {t("Ajouter un financeur")}
          </Link>
        </div> */}
      </div>

      <div className="sticky top-0 bg-background pb-3 z-20">
        <div className="flex items-center gap-3 justify-end mt-8 ">
          <div className="flex gap-1">
            <Button
              onClick={() => handleYearChange("prev")}
              className="bg-background flex size-8 items-center justify-center rounded-full p-0 transition-all hover:bg-gray-100"
              disabled={launchDate == (Number(yearParam) || year)}
            >
              <ChevronLeft className="text-foreground" />
            </Button>
            <Button
              onClick={() => handleYearChange("next")}
              className="bg-background flex size-8 items-center justify-center rounded-full p-0 transition-all hover:bg-gray-100"
              disabled={
                launchDate - 1 + expectedDurationYear <=
                (Number(yearParam) || year)
              }
            >
              <ChevronRight className="text-foreground" />
            </Button>
          </div>
          <Select value={year.toString()} onValueChange={handleSelectYear}>
            <SelectTrigger className="text-foreground/90 w-16 border-0 px-0 text-lg outline-none focus:ring-0 focus:ring-transparent">
              <SelectValue placeholder={year} />
            </SelectTrigger>
            <SelectContent>
              <SelectGroup>
                {arrYear.map((i, k) => (
                  <SelectItem value={"" + (launchDate + k)} key={k}>
                    {launchDate + k}
                  </SelectItem>
                ))}
              </SelectGroup>
            </SelectContent>
          </Select>
        </div>
        <div className="relative ml-auto mt-3 flex flex-wrap items-center gap-2 w-full">
          <div className="flex w-5/6 gap-2 ml-auto pl-4 pr-6">
            {listAllMonths.map((i, k) => (
              <div
                className={`border-foreground/5 flex-1 border-x text-center `}
                key={k}
              >
                {t(i)}
              </div>
            ))}
          </div>
        </div>
      </div>
      <NewContributions id={id} year={year} />
    </div>
  );
};

export default Contributions;
